import Vue from 'vue';

export function vueMixin (App) {
  // Expose Vue globally to the app.
  App.Vue = App.prototype.Vue = Vue;
}
